import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import classNames from 'classnames'
import AppBar from '@material-ui/core/AppBar';
import { useSnackbar } from 'notistack'
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import EnhancedEncryptionIcon from '@material-ui/icons/EnhancedEncryption';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl'
import Container from '@material-ui/core/Container'
import FormHelperText from '@material-ui/core/FormHelperText';
import styled from 'styled-components'
import { profileMutations } from '../../graphql/mutations'
import { useMutation } from '@apollo/react-hooks'


const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,

  },
  passwordIcon: {
    marginLeft: 8,
    fontSize: '20px',
  },
  passwordTitle: {
    fontSize: '14px',
    marginLeft: '-15px',
    textTransform: 'uppercase',
  },
  buttonColor: {
    marginRight: '-35px'
  },

  iconGrid: {
    fontSize: '16px',
    marginRight: '5px'
  },

  tollbarContainer: {
    paddingLeft: '0 !important',
    paddingRight: '0 !important'
  },

  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar
  },
  toolBarRight: {
    marginLeft: 'auto',
    margin: '0 8px'
  }
}))


const ProfileTitle = styled.div`
    flex-direction: column;
    margin-left: 30px;
    margin-top: 0px
`

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const ChangePassword = () => {

  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [senha, setPassword] = React.useState(null)
  const [atualizaSenha] = useMutation(profileMutations.EDIT_PASSWORD)
  const [novaSenha, setNewPassword] = React.useState(null)
  const [confirmPassword, setConfirmPassword] = React.useState(null)
  const [errorPassword, setErrorPassword] = React.useState(null)
  const [errorNewPassword, setErrorNewPassword] = React.useState(null)
  const [errorConfirmPassword, setErrorConfirmPassword] = React.useState(null)
  const [formTouched, setFormTouched] = React.useState(false)
  const { enqueueSnackbar } = useSnackbar()



  const handleClickOpen = () => {
    setOpen(true)
    setPassword("")
    setNewPassword("")
    setConfirmPassword("")
  }

  const handleClose = () => {
    setOpen(false)
  }

  const changeUserPassword = (e) => {
    if (!e.target.value) {
      setErrorPassword("Informe sua senha atual")
    } else {
      setErrorPassword("")
    }
    setPassword(e.target.value)
  }


  const changeNewUserPassword = (e) => {
    if (!e.target.value) {
      setErrorNewPassword("Informe sua nova senha")
    } else {
      setErrorNewPassword("")
    }

    setNewPassword(e.target.value)

  }


  const changeConfirmUserPassword = (e) => {
    if (!e.target.value) {
      setErrorConfirmPassword("Confirme sua nova senha")
    }

    if (novaSenha !== e.target.value) {
      setErrorConfirmPassword("As senhas não se coincidem")
    } else {
      setErrorConfirmPassword("")
    }

    setConfirmPassword(e.target.value)

  }


  const handleSubmit = (e) => {
    e.preventDefault()
    setFormTouched(true)
    
    if (senha && novaSenha && novaSenha === confirmPassword) {
      return atualizaSenha({
        variables: {
          senha: senha,
          novaSenha: novaSenha
        },
        update: () => enqueueSnackbar('Senha atualizada com sucesso') && setOpen(false)
      })
  
    } else {
      enqueueSnackbar('Preencha os dados corretamente') 
    }
  }


  return (
    <div>
      <Button onClick={handleClickOpen} color={'primary'} startIcon={<EnhancedEncryptionIcon color={'inherit'} className={classes.passwordIcon} />}>
        <ProfileTitle>
          <Typography variant="h6" className={classes.passwordTitle} color={'primary'} >Alterar Senha</Typography>
        </ProfileTitle>
      </Button>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Container className={classNames(classes.tollbarContainer)}>
            <Toolbar className={classNames(classes.toolbar)}>
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                   Alterar Senha
               </Typography>
              <Button autoFocus className={classNames(classes.toolbarRight)} color="inherit" type="submit" onClick={handleSubmit}>
                Salvar
               </Button>
            </Toolbar>
          </Container>
        </AppBar>
        <Container>
          <List>
            <form onSubmit={handleSubmit}>
              <FormControl fullWidth error={!!errorPassword && !!formTouched}>
                <InputLabel>Senha Atual</InputLabel>
                <Input
                  error={!!errorPassword && !!formTouched}
                  required
                  type="password"
                  value={senha}
                  name={'novaSenha'}
                  onChange={changeUserPassword}
                />

                <FormHelperText>{errorPassword}</FormHelperText>
              </FormControl>

              <FormControl error={!!errorNewPassword && !!formTouched} fullWidth>
                <InputLabel>Nova Senha</InputLabel>
                <Input
                  error={!!errorNewPassword && !!formTouched}
                  required
                  type="password"
                  value={novaSenha}
                  name={'novaSenha'}
                  onChange={changeNewUserPassword}
                />

                <FormHelperText>{errorNewPassword}</FormHelperText>


              </FormControl>

              <FormControl error={!!errorConfirmPassword && !!formTouched} fullWidth>
                <InputLabel>Confirmar nova senha</InputLabel>
                <Input
                  error={!!errorConfirmPassword && !!formTouched}
                  required
                  type="password"
                  value={confirmPassword}
                  name={'novaSenha'}
                  onChange={changeConfirmUserPassword}
                />

                <FormHelperText >{errorConfirmPassword}</FormHelperText>
              </FormControl>
            </form>
          </List>
        </Container>
      </Dialog>

    </div >
  )


}


export default ChangePassword
